export enum ProdutoEnum {
	GarantiaSetorPublico = 1,
	GarantiaSetorPrivado = 2,
	GarantiaObrigacoesPrivadas = 3,
	GarantiaVarejoSetorPublicoCIRC662 = 4,
	GarantiaVarejoSetorPrivadoCIRC662 = 5,
	GarantiaCorpSetorPublicoCIRC662 = 6
}
